export default __webpack_public_path__ + "6676e4e7f9c83d5039df3ac5127758c9.png";